import { Plugin, PluginKey } from "prosemirror-state";
import { ReactPluginView } from "../../../react/react-plugin-view";
import { EditorImageMenuPluginView } from "../components/EditorImageMenuPluginView/EditorImageMenuPluginView";
const imageMenuPluginKey = new PluginKey();
export function imageMenuPlugin(portalContainer, filestackService) {
    return new Plugin({
        key: imageMenuPluginKey,
        state: {
            init: () => null,
            apply: (tr, state) => {
                if (tr.getMeta(imageMenuPluginKey) !== undefined) {
                    return tr.getMeta(imageMenuPluginKey);
                }
                return state;
            },
        },
        view: (view) => new ReactPluginView(view, {
            portalContainer,
            component: EditorImageMenuPluginView,
            extraProps: {
                onFullscreen: (attrs) => filestackService.openModalGallery(view, attrs),
            },
        }),
    });
}
export function setImageMenuState(tr, state) {
    return tr.setMeta(imageMenuPluginKey, state);
}
export function getImageMenuState(state) {
    return imageMenuPluginKey.getState(state);
}
let hideImageMenuTimeout;
export function showImageMenu(view, target = null) {
    if (hideImageMenuTimeout) {
        window.clearTimeout(hideImageMenuTimeout);
    }
    if (target) {
        view.dispatch(setImageMenuState(view.state.tr, {
            target,
            pos: view.posAtDOM(target, 0),
        }));
    }
}
export function hideImageMenu(view) {
    if (hideImageMenuTimeout) {
        window.clearTimeout(hideImageMenuTimeout);
    }
    hideImageMenuTimeout = window.setTimeout(() => {
        if (!view.isDestroyed) {
            view.dispatch(setImageMenuState(view.state.tr, null));
        }
    }, 200);
}
